import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { FailedAttemptsSection } from './components/FailedAttemptsSection';
import { MechanismSection } from './components/MechanismSection';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { AudienceSection } from './components/AudienceSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { OfferSection } from './components/OfferSection';
import { Divider } from './components/ui/Divider';
import { Footer } from './components/Footer';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <main className="min-h-screen bg-dark text-white selection:bg-gold-500/30 selection:text-gold-300 overflow-x-hidden" data-id="element-0">
      <HeroSection data-id="element-1" />
      <Divider data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <FailedAttemptsSection data-id="element-4" />
      <Divider data-id="element-5" />
      <MechanismSection data-id="element-6" />
      <WhatYouGetSection data-id="element-7" />
      <Divider data-id="element-8" />
      <AudienceSection data-id="element-9" />
      <HowItWorksSection data-id="element-10" />
      <Divider data-id="element-11" />
      <ProofSection data-id="element-12" />
      <FAQSection data-id="element-13" />
      <OfferSection data-id="element-14" />

      <Footer data-id="element-15" />
    </main>;
}